module.exports = __webpack_public_path__ + "img/recording-file-page.7c9d7a81.svg";